"use client";

import { useEffect } from "react";
import { initFirebaseRemoteConfig } from "@/src/features/firebase";

export function FirebaseInitializer() {
  useEffect(() => {
    const initialize = async () => {
      await initFirebaseRemoteConfig();
    };
    initialize();
  }, []);

  return null;
}
